(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gift-card-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tgpc-gift-card')) {
    customElements.define('tgpc-gift-card', class extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select');
        this.preview = this.querySelector('[data-gift-card-preview]');
        this.nameLabel = this.querySelector('[data-gift-card-name]');
        this.updatePreview = () => {
          const selected = this.select.selectedOptions[0];
          this.preview.src = selected.dataset.image;
          this.preview.alt = selected.value;
          this.nameLabel.textContent = selected.value;
        };
        this.select.addEventListener('change', this.updatePreview);
        this.updatePreview();
      }

      disconnectedCallback() {
        this.select.removeEventListener('change', this.updatePreview);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pot-options"] && !Shopify.designMode) return;
  try {
    (window.tgpcInit = window.tgpcInit || []).push((scope) => {
    scope.querySelectorAll('[data-tgpc-pot-options]').forEach((wrapper) => {
      if (wrapper.dataset.initialized) return;
      wrapper.dataset.initialized = 'true';
      const form = wrapper.closest('form');
      const container = wrapper.querySelector('#infiniteoptions-container');
      const sizeOptions = Array.from(form.querySelectorAll('[data-option-name]'))
        .find((fieldset) => fieldset.dataset.optionName.toLowerCase() === 'size');
      let previousSize;
      let drag;
      let suppressClick = false;
      const stockRequests = new Map();
      const stockStates = new WeakMap();
      const clearPot = (group) => {
        const none = group.querySelector('input[type="radio"][value="None"]');
        if (!none) return;
        none.checked = true;
        none.dispatchEvent(new Event('change', { bubbles: true }));
      };

      const applyStock = (card, input, state) => {
        const group = card.closest('.addon-pot');
        card.dataset.potStock = state;
        const available = state === 'in-stock';
        input.setAttribute('aria-disabled', String(!available));
        if (!available && input.checked) clearPot(group);
        const disabled = !available || group.hasAttribute('disabled');
        if (input.disabled !== disabled) input.disabled = disabled;
        let badge = card.querySelector('.tgpc-pot-options__stock');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'tgpc-pot-options__stock';
          card.append(badge);
        }
        const labels = { 'in-stock': 'In stock', 'sold-out': 'Sold out', checking: 'Checking stock…', unknown: 'Stock unavailable' };
        if (badge.textContent !== labels[state]) badge.textContent = labels[state];
      };

      const checkStock = () => {
        container.querySelectorAll('.spb-productoptionswatchwrapper').forEach((card) => {
          const input = card.querySelector('input[type="radio"]');
          if (!input || input.value === 'None') return;
          const state = stockStates.get(input);
          if (state) { applyStock(card, input, state); return; }
          if (card.closest('.addon-pot').hasAttribute('disabled')) return;
          const data = window.Shoppad?.$?.(input).data();
          if (!data?.productHandle || !data.variantId) return;
          stockStates.set(input, 'checking');
          applyStock(card, input, 'checking');
          if (!stockRequests.has(data.productHandle)) {
            const root = window.Shopify?.routes?.root || '/';
            const request = fetch(`${root}products/${encodeURIComponent(data.productHandle)}.js`, {
              headers: { Accept: 'application/json' },
              signal: AbortSignal.timeout(10000)
            }).then((response) => {
              if (!response.ok) throw new Error('Stock lookup failed');
              return response.json();
            }).catch(() => null);
            stockRequests.set(data.productHandle, request);
          }
          stockRequests.get(data.productHandle).then((product) => {
            const variant = product?.variants?.find((item) => String(item.id) === String(data.variantId));
            const result = typeof variant?.available === 'boolean' ? (variant.available ? 'in-stock' : 'sold-out') : 'unknown';
            stockStates.set(input, result);
            if (wrapper.isConnected) applyStock(card, input, result);
          });
        });
      };

      wrapper.addEventListener('pointerdown', (event) => {
        suppressClick = false;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        const rail = event.target.closest('.addon-pot > .spb-label-tooltip + span');
        if (!rail) return;
        drag = { rail, id: event.pointerId, x: event.clientX, y: event.clientY, left: rail.scrollLeft, active: false };
      });
      wrapper.addEventListener('pointermove', (event) => {
        if (!drag || event.pointerId !== drag.id) return;
        if (!event.buttons) { drag = undefined; return; }
        const distance = event.clientX - drag.x;
        if (!drag.active && Math.abs(distance) > 6 && Math.abs(distance) > Math.abs(event.clientY - drag.y)) {
          drag.active = true;
          drag.rail.setPointerCapture(event.pointerId);
          drag.rail.classList.add('is-dragging');
        }
        if (drag.active) {
          event.preventDefault();
          drag.rail.scrollLeft = drag.left - distance;
          suppressClick = true;
        }
      });
      const endDrag = () => {
        if (!drag) return;
        drag.rail.classList.remove('is-dragging');
        if (drag.rail.hasPointerCapture(drag.id)) drag.rail.releasePointerCapture(drag.id);
        drag = undefined;
      };
      wrapper.addEventListener('pointerup', endDrag);
      wrapper.addEventListener('pointercancel', endDrag);
      wrapper.addEventListener('click', (event) => {
        if (suppressClick && event.detail > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const card = event.target.closest('.spb-productoptionswatchwrapper');
        const input = card?.querySelector('input[type="radio"]');
        if (input && input.value !== 'None' && card.dataset.potStock !== 'in-stock') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (event.target.matches('input')) return;
        if (input?.checked && !input.disabled && input.value !== 'None') {
          event.preventDefault();
          clearPot(card.closest('.addon-pot'));
        }
      }, true);
      wrapper.addEventListener('keydown', (event) => {
        if (event.key !== ' ' && event.key !== 'Enter') return;
        const input = event.target;
        if (!input.matches('input[type="radio"]') || input.disabled) return;
        if (input.checked && input.value !== 'None') {
          event.preventDefault();
          clearPot(input.closest('.addon-pot'));
        }
      });

      const syncSize = () => {
        const field = container.querySelector('.addon-pot-size input');
        if (!field) return;
        const size = sizeOptions?.querySelector('input:checked')?.value || '';
        if (size === previousSize && field.value === size) return;
        if (previousSize !== undefined && previousSize !== size) {
          container.querySelectorAll('.addon-pot:not(.addon-pot-size)').forEach((group) => {
            const none = group.querySelector('input[type="radio"][value="None"]');
            if (none && group.querySelector('input:checked') !== none) {
              none.checked = true;
              none.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }
        previousSize = size;
        field.value = size;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      };

      sizeOptions?.addEventListener('change', syncSize);
      const observer = new MutationObserver(() => { syncSize(); checkStock(); });
      observer.observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
      syncSize();
      checkStock();
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(wrapper)) observer.disconnect();
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
